export const Field = ({ label, hint, error, required, children, className = "" }) => (
  <div className={`flex flex-col gap-1.5 ${className}`}>
    <label className="text-[13px] font-extrabold text-cocoa">
      {label}
      {required && <span className="ml-1 text-coralInk">*</span>}
    </label>
    {children}
    {hint && <p className="text-[12px] font-medium text-cocoa/70">{hint}</p>}
    {error && <p className="text-[12px] font-bold text-coralInk">{error}</p>}
  </div>
);

const inputBase =
  "min-h-[52px] w-full rounded-control bg-cream border border-line px-5 text-sm font-semibold text-cocoa placeholder:font-medium placeholder:text-cocoa/40 transition-shadow focus:outline-none focus:border-forest/40 focus:ring-4 focus:ring-amber/45";

export const TextInput = ({ className = "", ...props }) => (
  <input className={`${inputBase} ${className}`} {...props} />
);

export const SelectInput = ({ className = "", children, ...props }) => (
  <select className={`${inputBase} ${className}`} {...props}>
    {children}
  </select>
);

export const TextArea = ({ className = "", ...props }) => (
  <textarea
    rows={4}
    className={`w-full rounded-[24px] border border-line bg-cream px-5 py-4 text-sm font-semibold text-cocoa placeholder:font-medium placeholder:text-cocoa/40 focus:border-forest/40 focus:outline-none focus:ring-4 focus:ring-amber/45 ${className}`}
    {...props}
  />
);

export const CheckboxRow = ({ label, description, ...props }) => (
  <label className="flex cursor-pointer items-start gap-3 rounded-[24px] border border-line bg-cream p-4 transition-colors hover:bg-sageSoft">
    <input
      type="checkbox"
      className="mt-0.5 h-5 w-5 shrink-0 accent-[var(--brand-forest)]"
      {...props}
    />
    <span className="text-sm">
      <span className="font-bold text-cocoa">{label}</span>
      {description && <span className="mt-1 block text-[12px] font-medium text-cocoa/75">{description}</span>}
    </span>
  </label>
);

export const FormNotice = ({ tone = "info", children, testId }) => {
  const tones = {
    info: { bg: "var(--brand-sage-soft)", color: "var(--brand-cocoa)" },
    error: { bg: "rgba(196,54,56,0.14)", color: "var(--brand-cocoa)" },
    warn: { bg: "rgba(246,136,37,0.22)", color: "var(--brand-cocoa)" },
  }[tone];
  return (
    <div
      data-testid={testId}
      role={tone === "error" ? "alert" : "status"}
      className="rounded-[24px] p-4 text-sm font-semibold leading-relaxed"
      style={{ background: tones.bg, color: tones.color }}
    >
      {children}
    </div>
  );
};
